import React from 'react';
import Breadcrumbs from "../../components/Breadcrumbs/Breadcrumbs";
import ContentPanel from "../../components/ContentPanel/ContentPanel";
import Skeleton from "../../components/Skeleton/Skeleton";
import store from "../../store";
import {Helmet} from "react-helmet";

const ourStory = () => (

  <div className="wrapper">
      <Helmet>
          {
              store.getState().sitemapData.sitemap ? store.getState().sitemapData.sitemap.map((row) => {
                  return row.rowTitle === "About" ? row.sections.map((section) => {
                      return section.title === "Our Story" ? <meta name="description" content={section.content['seo-description']}/> : null
                  }) : null
              }) : null
          }
      </Helmet>
    <Breadcrumbs/>
    <ContentPanel
      skeleton={<Skeleton type="MAIN_PANEL"/>}
      errorTemplate={<Skeleton type="MAIN_PANEL_ERROR"/>}
      templateUrl="./content/about/page-components/text-block/our-story-heading.html"
    />
    <ContentPanel
      skeleton={<Skeleton type="LONG_CONTENT_PAGE"/>}
      errorTemplate={<Skeleton type="LONG_CONTENT_PAGE_ERROR"/>}
      templateUrl="./content/about/page-components/content-detail/our-story.html"
    />
  </div>
);

export default ourStory;



// WEBPACK FOOTER //
// ./src/pages/About/OurStory.js